/* eslint-disable indent */
// Code copied from the old ANZCA site (written in JQuery) and converted to TS
const initialiseLibrarySearch = (): void => {
    const wildcardReplace = (text: string): string => {
        const replacements = [
            [/anaesth/ig, 'an?esth'],
            [/anesth/ig, 'an?esth'],
            [/apnoea/ig, 'apn?ea'],
            [/apnea/ig, 'apn?ea'],
            [/esophag/ig, '?esophag'],
            [/oesophag/ig, '?esophag'],
            [/o\?esophag/ig, '?esophag'],
            [/paediat/ig, 'p?ediat'],
            [/pediat/ig, 'p?ediat'],
            [/labour/ig, 'labo?r'],
            [/labor/ig, 'labo?r'],
            [/anaemia/ig, 'an?emia'],
            [/anemia/ig, 'an?emia'],
            [/haemoglobin/ig, 'h?emoglobin'],
            [/hemoglobin/ig, 'h?emoglobin'],
            [/leukaemia/ig, 'leuk?emia'],
            [/leukemia/ig, 'leuk?emia'],
            [/faeces/ig, 'f?eces'],
            [/feces/ig, 'f?eces'],
            [/haemorrhoid/ig, 'h?emorrhoid'],
            [/hemorrhoid/ig, 'h?emorrhoid'],
            [/haemophilia/ig, 'h?emophilia'],
            [/hemophilia/ig, 'h?emophilia'],
            [/haematotoxicity/ig, 'h?ematotoxicity'],
            [/hematotoxicity/ig, 'h?ematotoxicity'],
            [/gynaecology/ig, 'gyn?ecology'],
            [/gynecology/ig, 'gyn?ecology'],
            [/ischaemic/ig, 'isch?emic'],
            [/ischemic/ig, 'isch?emic'],
            [/caesarean/ig, 'c?esarean'],
            [/cesarean/ig, 'c?esarean'],
            [/orthopaedic/ig, 'orthop?edic'],
            [/orthopedic/ig, 'orthop?edic'],
            [/synaeresis/ig, 'syn?eresis'],
            [/syneresis/ig, 'syn?eresis'],
            [/etiology/ig, '?etiology'],
            [/aetiology/ig, '?etiology'],
            [/a\?etiology/ig, '?etiology'],
            [/diarrhoea/ig, 'diarrh?ea'],
            [/diarrhea/ig, 'diarrh?ea'],
            [/coeliac/ig, 'c?eliac'],
            [/celiac/ig, 'c?eliac'],
            [/dyspnoea/ig, 'dyspn?ea'],
            [/dyspnea/ig, 'dyspn?ea'],
            [/edema/ig, '?edema'],
            [/oedema/ig, '?edema'],
            [/o\?edema/ig, '?edema'],
            [/estrogen/ig, '?estrogen'],
            [/oestrogen/ig, '?estrogen'],
            [/o\?estrogen/ig, '?estrogen'],
            [/gonorrhoea/ig, 'gonorrh?ea'],
            [/gonorrhea/ig, 'gonorrh?ea'],
            [/menorrhoea/ig, 'menorrh?ea'],
            [/menorrhea/ig, 'menorrh?ea'],
            [/homoeopath/ig, 'hom?eopath'],
            [/homeopath/ig, 'hom?eopath'],
            [/behaviour/ig, 'behavio?r'],
            [/behavior/ig, 'behavio?r'],
            [/colour/ig, 'colo?r'],
            [/color/ig, 'colo?r'],
            [/tumour/ig, 'tumo?r'],
            [/tumor/ig, 'tumo?r'],
            [/humour/ig, 'humo?r'],
            [/humor/ig, 'humo?r'],
            [/odour/ig, 'odo?r'],
            [/odor/ig, 'odo?r'],
            [/vapour/ig, 'vapo?r'],
            [/vapor/ig, 'vapo?r'],
            [/fetal/ig, 'f?etal'],
            [/foetal/ig, 'f?etal']
        ];
        let modifiedText = text;
        replacements.forEach(([regex, replacement]) => {
            modifiedText = modifiedText.replace(regex, replacement as string);
        });
        return modifiedText;
    };

    const handleSearch = (
        searchText: string,
        selectedValue: string,
        errorMessageLabel: HTMLLabelElement,
        baseUrl: string,
        BZUrl: string
    ): void => {
        if (searchText.trim() === '') {
            errorMessageLabel.style.display = 'block';
            return;
        }

        errorMessageLabel.style.display = 'none';
        let searchWild = wildcardReplace(searchText);
        const wildSwitch = 0;

        if (wildSwitch === 0) {
            searchWild = searchText;
        }

        let url = '';
        switch (selectedValue) {
            case '1':
                url = `${baseUrl}?clusterResults=on&groupVariantRecords=off&queryString=${searchWild}`;
                break;
            case '2':
                url = `${baseUrl}?clusterResults=on&groupVariantRecords=off&format=Artchap&queryString=${searchWild}`;
                break;
            case '3':
                url = `${baseUrl}?clusterResults=on&groupVariantRecords=off&format=Book&queryString=(ti:${searchWild})+OR+(au:${searchText})`;
                break;
            case '4':
                url = `${baseUrl}?clusterResults=on&groupVariantRecords=off&format=Jrnl&queryString=ti:${searchWild}`;
                break;
            case '5':
                url = `${BZUrl}${searchText}`;
                break;
            default:
                break;
        }
        window.open(url);
    };

    const handleKeyPress = (e: KeyboardEvent, searchText: string, selectedValue: string, errorMessageLabel: HTMLLabelElement, baseUrl: string, BZUrl: string): void => {
        if (e.key === 'Enter') {
            handleSearch(searchText, selectedValue, errorMessageLabel, baseUrl, BZUrl);
        }
    };

    const handleReset = (
        searchTextInput: HTMLInputElement,
        errorMessageLabel: HTMLLabelElement,
        radioButtons: NodeListOf<HTMLInputElement>,
        setSearchText: (text: string) => void,
        setSelectedValue: (value: string) => void
    ): void => {
        searchTextInput.value = '';
        searchTextInput.placeholder = 'search for books, journals, articles and more…';
        errorMessageLabel.style.display = 'none';
        radioButtons.forEach(radio => {
            radio.checked = radio.value === '1';
        });
        setSearchText('');
        setSelectedValue('1');
    };

    const handleFilterChange = (searchTextInput: HTMLInputElement, value: string, newPlaceholder: string): void => {
        searchTextInput.placeholder = newPlaceholder;
    };

    document.addEventListener('DOMContentLoaded', () => {
        const searchTextInput = document.getElementById('discSrch') as HTMLInputElement;
        const searchButton = document.getElementById('subSrch') as HTMLButtonElement;
        const resetButton = document.getElementById('resetSrch') as HTMLAnchorElement;
        const errorMessageLabel = document.getElementById('errorMessage') as HTMLLabelElement;
        const radioButtons = document.querySelectorAll('input[name="radioqueryFormat"]') as NodeListOf<HTMLInputElement>;

        let searchText = '';
        let selectedValue = '1';
        const baseUrl = 'https://anzca.on.worldcat.org/external-search';
        const BZUrl = 'https://api.thirdiron.com/v2/libraries/1231/external-search?query=';

        if (searchTextInput) {
            searchTextInput.addEventListener('input', (e: Event) => {
                searchText = (e.target as HTMLInputElement).value;
            });

            searchTextInput.addEventListener('keypress', (e: KeyboardEvent) => {
                handleKeyPress(e, searchText, selectedValue, errorMessageLabel, baseUrl, BZUrl);
            });
        }

        if (searchButton) {
            searchButton.addEventListener('click', () => {
                handleSearch(searchText, selectedValue, errorMessageLabel, baseUrl, BZUrl);
            });
        }

        if (resetButton) {
            resetButton.addEventListener('click', () => {
                handleReset(searchTextInput, errorMessageLabel, radioButtons, (text: string) => {
                    searchText = text;
                }, (value: string) => {
                    selectedValue = value;
                });
            });
        }

        if (radioButtons && radioButtons.length > 0) {
            radioButtons.forEach(radio => {
                radio.addEventListener('change', (e: Event) => {
                    const target = e.target as HTMLInputElement;
                    selectedValue = target.value;
                    switch (target.value) {
                        case '1':
                            handleFilterChange(searchTextInput, '1', 'search for books, journals, articles and more…');
                            break;
                        case '2':
                            handleFilterChange(searchTextInput, '2', 'search for articles…');
                            break;
                        case '3':
                            handleFilterChange(searchTextInput, '3', 'search by book title or author…');
                            break;
                        case '4':
                            handleFilterChange(searchTextInput, '4', 'search by journal title…');
                            break;
                        case '5':
                            handleFilterChange(searchTextInput, '5', 'search BrowZine by journal title, subject or ISSN…');
                            break;
                        default:
                            break;
                    }
                    searchTextInput.focus();
                });
            });
        }
    });
};

export { initialiseLibrarySearch };
